/**
 * @returns {string[][]}
 */
export const transpose2dArray = grid => {
  const transposed = []
  grid.forEach((column, y) => {
    column?.length &&
      column.forEach((value, x) => {
        if (value !== undefined || value !== null) {
          if (!transposed[x]) transposed[x] = []
          transposed[x][y] = value
        }
      })
  })

  return transposed
}
